const logo = require('@/assets/images/logo.png')
const menuIcon = require('@/assets/images/menu.svg')
const closeIcon = require('@/assets/images/close.png')
const qrCode = require('@/assets/images/footer/code.png')
const homeHeroImage = require('@/assets/images/bg1-home.webp')
const aboutPreviewImage = require('@/assets/images/about-preview.webp')
const aboutHeroImage = require('@/assets/images/about-hero.webp')
const officeImage = require('@/assets/images/contact2.jpg')
const footerPhoneIcon = require('@/assets/images/footer/footer-phone.png')
const footerEmailIcon = require('@/assets/images/footer/footer-email.png')
const footerAddressIcon = require('@/assets/images/footer/footer-address.png')
const valueMissionIcon = require('@/assets/images/detail/ico-1.png')
const valueVisionIcon = require('@/assets/images/detail/ico-2.png')
const valuePhilosophyIcon = require('@/assets/images/detail/ico-3.png')
const valueStrategyIcon = require('@/assets/images/detail/ico-4.png')
const medicalIcon = require('@/assets/images/product/ico-hos-w.png')
const dataIcon = require('@/assets/images/product/ico-com-w.png')
const logoSrm = require('@/assets/images/logo/srm.jpeg')
const logoJsfy = require('@/assets/images/logo/jsfy.png')
const logoNjgl = require('@/assets/images/logo/njgl.webp')
const logoJsszy = require('@/assets/images/logo/jsszy.webp')
const logoWj = require('@/assets/images/logo/wj.jpg')
const logoJssb = require('@/assets/images/logo/jssb-optimized.webp')
const logoLygrm = require('@/assets/images/logo/lygrm-optimized.webp')
const logoLygfy = require('@/assets/images/logo/lygfy.webp')

const medicalOverviewPreview = {
  theme: 'medical',
  eyebrow: '方案总览',
  title: '数字医疗协同门户',
  subtitle: '随访、体检、筛查与居民档案在同一工作台协同推进',
  status: '实时同步',
  pill: '公共卫生',
  metrics: [
    { label: '居民档案', value: '24,680' },
    { label: '本周任务', value: '128' },
    { label: '完成率', value: '96%' }
  ],
  panels: [
    {
      title: '服务中心',
      items: ['签约居民管理', '随访任务分发', '健康档案归集']
    },
    {
      title: '重点提醒',
      steps: [
        { title: '慢病复诊', meta: '优先完成 12 人' },
        { title: '体检回访', meta: '今日新增 8 条' },
        { title: '筛查复核', meta: '待确认 3 项' }
      ]
    },
    {
      title: '协同入口',
      tags: ['家庭医生', '体检中心', '妇幼筛查', '基层协同']
    }
  ],
  footer: ['签约履约', '流程联动', '数据沉淀']
}

const familyDoctorPreview = {
  theme: 'medical',
  eyebrow: '家庭医生签约',
  title: '随访驾驶舱',
  subtitle: '围绕居民画像、履约节点与团队任务形成闭环',
  status: '签约管理',
  metrics: [
    { label: '签约居民', value: '2,468' },
    { label: '待随访', value: '36' },
    { label: '履约率', value: '94%' }
  ],
  panels: [
    {
      title: '今日任务',
      items: ['高血压复诊 12 人', '孕产健康回访 6 人', '重点人群建档 4 人']
    },
    {
      title: '居民标签',
      tags: ['慢病管理', '老年人服务', '孕产随访', '重点人群']
    },
    {
      title: '团队协同',
      steps: [
        { title: '任务分发', meta: '按团队自动归类' },
        { title: '服务留痕', meta: '记录履约节点' },
        { title: '结果汇总', meta: '形成持续档案' }
      ]
    }
  ],
  footer: ['档案管理', '随访计划', '服务提醒']
}

const checkupPreview = {
  theme: 'medical',
  eyebrow: '健康体检',
  title: '体检流程看板',
  subtitle: '检前预约、检中执行、检后回访在同一链路中联动',
  status: '全流程覆盖',
  metrics: [
    { label: '预约排期', value: '286' },
    { label: '报告完成', value: '91%' },
    { label: '复检提醒', value: '24' }
  ],
  panels: [
    {
      title: '进度概览',
      bars: [
        { label: '检前准备', value: '92%', ratio: 92 },
        { label: '检中执行', value: '87%', ratio: 87 },
        { label: '检后回访', value: '74%', ratio: 74 }
      ]
    },
    {
      title: '服务节点',
      steps: [
        { title: '预约登记', meta: '自动分配时段' },
        { title: '现场引导', meta: '支持项目流转' },
        { title: '结果归档', meta: '回访任务联动' }
      ]
    },
    {
      title: '重点模块',
      tags: ['预约管理', '体检分组', '报告回传', '异常提醒']
    }
  ],
  footer: ['检前', '检中', '检后']
}

const screeningPreview = {
  theme: 'medical',
  eyebrow: '筛查管理',
  title: '两癌筛查工作台',
  subtitle: '项目进度、对象管理与复核流程清晰呈现',
  status: '项目推进',
  metrics: [
    { label: '筛查对象', value: '5,240' },
    { label: '完成登记', value: '4,986' },
    { label: '复核处理', value: '112' }
  ],
  panels: [
    {
      title: '项目流程',
      steps: [
        { title: '对象建册', meta: '街道与社区协同' },
        { title: '筛查执行', meta: '结果实时回传' },
        { title: '异常复核', meta: '统一跟进闭环' }
      ]
    },
    {
      title: '统计标签',
      tags: ['人群筛查', '妇幼协同', '项目台账', '结果追踪']
    },
    {
      title: '异常提醒',
      items: ['待复核样本 18 份', '需回访对象 27 人', '街道补录 6 条']
    }
  ],
  footer: ['对象管理', '项目协同', '结果跟踪']
}

const dataOverviewPreview = {
  theme: 'data',
  eyebrow: '平台总览',
  title: '数据空间能力中心',
  subtitle: '平台建设、业务协同与可信流通在同一界面中呈现',
  status: '持续运营',
  pill: '可信协同',
  metrics: [
    { label: '接入平台', value: '16' },
    { label: '协同任务', value: '83' },
    { label: '安全策略', value: '27' }
  ],
  panels: [
    {
      title: '平台模块',
      items: ['数字化服务平台', '学术营销协同', '隐私计算服务']
    },
    {
      title: '运营进度',
      bars: [
        { label: '业务接入', value: '88%', ratio: 88 },
        { label: '数据治理', value: '76%', ratio: 76 },
        { label: '安全审计', value: '93%', ratio: 93 }
      ]
    },
    {
      title: '能力关键词',
      tags: ['平台建设', '联合建模', '隐私保护', '可信流通']
    }
  ],
  footer: ['数字化服务', '学术营销', '隐私计算']
}

const servicePlatformPreview = {
  theme: 'data',
  eyebrow: '数字化服务',
  title: '综合服务工作台',
  subtitle: '帮助组织在转型过程中统一查看服务、内容与运营节点',
  status: '业务转型',
  metrics: [
    { label: '服务计划', value: '42' },
    { label: '重点触点', value: '126' },
    { label: '执行反馈', value: '89%' }
  ],
  panels: [
    {
      title: '业务板块',
      items: ['服务活动管理', '内容排期协同', '客户触点沉淀']
    },
    {
      title: '阶段推进',
      steps: [
        { title: '需求归集', meta: '梳理目标场景' },
        { title: '平台联动', meta: '统一运营视图' },
        { title: '反馈沉淀', meta: '形成持续优化' }
      ]
    },
    {
      title: '重点标签',
      tags: ['数字化转型', '服务协同', '触点运营', '策略部署']
    }
  ],
  footer: ['平台视图', '业务协同', '持续反馈']
}

const academicMarketingPreview = {
  theme: 'data',
  eyebrow: '学术营销',
  title: '线上学术协同页',
  subtitle: '虚拟拜访、会议活动与内容传播统一组织',
  status: '内容协同',
  metrics: [
    { label: '会议活动', value: '18' },
    { label: '医生触达', value: '3,420' },
    { label: '内容完成', value: '95%' }
  ],
  panels: [
    {
      title: '活动排期',
      items: ['线上学术会议', '虚拟拜访跟进', '专题内容更新']
    },
    {
      title: '传播进度',
      bars: [
        { label: '内容准备', value: '96%', ratio: 96 },
        { label: '医生触达', value: '82%', ratio: 82 },
        { label: '反馈归集', value: '74%', ratio: 74 }
      ]
    },
    {
      title: '核心模块',
      tags: ['内容中心', '会议管理', '拜访记录', '效果分析']
    }
  ],
  footer: ['虚拟拜访', '会议运营', '传播分析']
}

const secureDataSpacePreview = {
  theme: 'security',
  eyebrow: '安全平台',
  title: '可信数据流通页',
  subtitle: '围绕联合建模、隐私查询与审计追踪组织平台能力',
  status: '隐私计算',
  metrics: [
    { label: '联合节点', value: '12' },
    { label: '审计任务', value: '64' },
    { label: '安全等级', value: 'A+' }
  ],
  panels: [
    {
      title: '核心能力',
      tags: ['联邦学习 FL', '多方计算 MPC', '可信执行环境 TEE']
    },
    {
      title: '处理链路',
      steps: [
        { title: '本地留存', meta: '原始数据不出域' },
        { title: '联合计算', meta: '支持安全查询与建模' },
        { title: '审计追踪', meta: '全流程可追溯' }
      ]
    },
    {
      title: '风险控制',
      bars: [
        { label: '数据安全', value: '99%', ratio: 99 },
        { label: '权限校验', value: '97%', ratio: 97 },
        { label: '过程审计', value: '95%', ratio: 95 }
      ]
    }
  ],
  footer: ['联合建模', '安全查询', '可信审计']
}

export const companyProfile = {
  name: '南京乐康数字科技有限公司',
  shortName: '乐康数科',
  description:
    '专注医疗体系数据空间安全，提供数据标准规范、数据强化治理、数据安全保障等数智化解决方案。',
  mission: '数据标准规范、数据强化治理、数据安全保障',
  slogan: '因为信任，所以简单',
  phone: '3679433105',
  phoneHref: 'tencent://message/?uin=3679433105',
  email: 'contact@alekang.com',
  emailHref: 'mailto:contact@alekang.com',
  address: '江苏省南京市建邺区广聚路31号安科大厦A座16层',
  publicAccountLabel: '微信公众号',
  recordNumber: '苏ICP备2024127805号',
  recordUrl: 'https://beian.miit.gov.cn',
  mapCenter: {
    lng: 118.74033165287114,
    lat: 31.984024041630943
  },
  logo,
  menuIcon,
  closeIcon,
  qrCode,
  footerIcons: {
    phone: footerPhoneIcon,
    email: footerEmailIcon,
    address: footerAddressIcon
  }
}

export const navigationItems = [
  {
    name: '首页',
    path: '/index',
    children: []
  },
  {
    name: '核心产品',
    path: '/product',
    children: [
      {
        name: '数字医疗',
        path: '/product/medical'
      },
      {
        name: '数据空间',
        path: '/product/digitalize'
      }
    ]
  },
  {
    name: '关于我们',
    path: '/about',
    children: [
      {
        name: '公司简介',
        path: '/about/detail'
      }
    ]
  },
  {
    name: '联系我们',
    path: '/contact',
    children: []
  }
]

export const homePage = {
  hero: {
    eyebrow: '爱乐康官方网站',
    title: '面向临床研究与医疗数据协同 平台',
    description:
      '南京乐康数字科技有限公司以 clinical EDC、研究工作台、数据报表与可信数据空间为核心，帮助医疗与科研场景把流程、数据、安全和协作稳定连接起来。',
    notes: [
      'Clinical EDC',
      'Research Workbench',
      'Datart / GoView',
      '可信数据空间'
    ],
    stats: [
      { value: '5', label: '核心交付端' },
      { value: '14+', label: '业务能力域' },
      { value: 'EDC', label: '临床数据采集' }
    ],
    image: homeHeroImage
  },
  platformPreview: dataOverviewPreview,
  platformModules: [
    {
      number: '01',
      kicker: 'Clinical EDC',
      title: '临床研究数据采集与质控',
      text: '围绕研究、中心、受试者、访视、CRF、疑问、审计和导出建立完整的 EDC 工作流。',
      items: ['研究与中心管理', 'CRF 动态录入', '疑问与审计闭环']
    },
    {
      number: '02',
      kicker: 'Research Workbench',
      title: '个人研究工作台',
      text: '面向研究者提供独立登录、研究范围切换、设计配置、数据分析、报告下载和外部集成。',
      items: ['研究上下文', '设计与配置包', '分析与报告']
    },
    {
      number: '03',
      kicker: 'GoView / Datart',
      title: '报表分析与可视化大屏',
      text: '在 GoView 技术栈中承载 Datart-like 的数据源、视图、图表、仪表板、故事板和分享能力。',
      items: ['数据源与 SQL 视图', '拖拽式图表', '大屏与故事板']
    },
    {
      number: '04',
      kicker: 'Alekang Pro',
      title: '统一权限、流程与基础设施',
      text: '基于 Alekang Vue Pro 提供系统管理、基础设施、会员、流程、CRM、ERP、IoT、AI 等平台能力。',
      items: ['统一认证权限', '文件与任务调度', '审计与租户隔离']
    }
  ],
  capabilities: [
    {
      title: '规范化数据底座',
      description:
        '将临床研究、公共卫生与数据空间中的核心对象统一沉淀，减少跨系统协同中的口径偏差。',
      icon: valueMissionIcon
    },
    {
      title: '全过程治理闭环',
      description:
        '通过权限、流程、日志、质控、审计与报表联动，把数据治理落到日常工作流中。',
      icon: valueVisionIcon
    },
    {
      title: '可信安全协作',
      description:
        '围绕租户隔离、角色授权、操作追踪、文件治理与数据访问控制，支撑长期可信协作。',
      icon: valueStrategyIcon
    }
  ],
  deliveryFlow: [
    {
      step: '01',
      title: '梳理场景',
      text: '确认研究、中心、角色、数据来源、审批与报表目标。'
    },
    {
      step: '02',
      title: '配置平台',
      text: '完成用户、权限、菜单、表单、流程、数据源和移动端入口配置。'
    },
    {
      step: '03',
      title: '数据复演',
      text: '基于克隆库开展迁移复演、计数对账、角色抽样与关键流程核验。'
    },
    {
      step: '04',
      title: '上线运营',
      text: '按切换窗口执行发布、监控、回退预案和持续优化。'
    }
  ],
  trustPoints: [
    '统一后台、研究端、大屏端与移动端交付',
    '支持临床研究真实流程与多角色协作',
    '以可复演的数据迁移和验收证据推进上线'
  ],
  products: [
    {
      title: '数字医疗',
      path: '/product/medical',
      summary:
        '围绕家庭医生签约随访、健康体检与筛查管理，支撑基层医疗与公共卫生服务流程。',
      points: ['家庭医生签约随访系统', '健康体检管理系统', '两癌筛查管理系统'],
      icon: medicalIcon,
      preview: medicalOverviewPreview
    },
    {
      title: '数据空间',
      path: '/product/digitalize',
      summary:
        '围绕数字化服务、学术营销与隐私计算，帮助机构建立更高效、更可信的数据协同能力。',
      points: [
        '好心大夫数字化服务综合平台',
        '医药数字化学术营销平台',
        '医疗体系数据空间安全平台'
      ],
      icon: dataIcon,
      preview: dataOverviewPreview
    }
  ],
  clients: [
    {
      name: '江苏省人民医院',
      logo: logoSrm
    },
    {
      name: '江苏省妇幼保健院',
      logo: logoJsfy
    },
    {
      name: '南京鼓楼医院',
      logo: logoNjgl
    },
    {
      name: '江苏省中医院',
      logo: logoJsszy
    },
    {
      name: '中国人民武装警察部队特色医学中心',
      logo: logoWj
    },
    {
      name: '江苏省苏北人民医院',
      logo: logoJssb
    },
    {
      name: '连云港市第一人民医院',
      logo: logoLygrm
    },
    {
      name: '连云港市妇幼保健院',
      logo: logoLygfy
    }
  ],
  aboutPreview: {
    eyebrow: '关于乐康数科',
    title: '从可信数据空间出发，服务更清晰的数字化实践',
    description:
      '乐康数科专注于构建可信的数据空间。我们秉承"因为信任，所以简单"的经营理念，致力于简化数据的复杂性，让信息的力量更加直观和易于管理。',
    image: aboutPreviewImage
  },
  contactCta: {
    eyebrow: '商务合作',
    title: '欢迎与我们沟通您的场景与目标',
    description:
      '无论是数字医疗建设，还是数据空间安全与治理需求，我们都希望以更稳妥、更清晰的方式参与其中。'
  }
}

export const productPages = {
  medical: {
    eyebrow: '核心产品',
    label: '数字医疗',
    title: '围绕基层公共卫生场景，构建连续、清晰的数字医疗服务流程',
    intro:
      '我们将数字化能力落到签约随访、体检管理与筛查协同等具体场景中，帮助机构把服务链路、数据沉淀与执行效率连接起来。',
    bannerPreview: medicalOverviewPreview,
    bannerCaption: '面向连续服务场景的产品组合',
    highlights: ['签约随访管理', '检前检中检后全流程', '公共卫生筛查协同'],
    sections: [
      {
        id: 'family-doctor',
        title: '家庭医生签约随访系统',
        summary:
          '聚焦基层医疗与连续随访管理，帮助机构提升签约服务、档案维护与居民健康跟踪效率。',
        points: [
          '面向签约服务与持续随访场景',
          '支持服务过程留痕与数据沉淀',
          '强化基层医疗协同效率'
        ],
        preview: familyDoctorPreview
      },
      {
        id: 'checkup',
        title: '健康体检管理系统',
        summary: '【检前+检中+检后】体检流程全覆盖，面向基层公共卫生服务。',
        points: [
          '支持体检流程全周期管理',
          '适配公共卫生与健康管理场景',
          '提升体检服务协同效率'
        ],
        preview: checkupPreview
      },
      {
        id: 'screening',
        title: '两癌筛查管理系统',
        summary:
          '面向妇幼与公共卫生筛查场景，支持筛查流程协同、数据管理与项目推进。',
        points: [
          '覆盖筛查项目执行链路',
          '便于数据归集与过程追踪',
          '强化筛查项目协同管理'
        ],
        preview: screeningPreview
      }
    ],
    summary: {
      eyebrow: '产品价值',
      title: '把业务场景、流程执行与数据沉淀稳定连接起来',
      text: '数字医疗产品矩阵聚焦真实服务场景，帮助机构在连续运营中建立更清晰的流程体验与更可靠的数据基础。',
      items: ['基层医疗服务', '公共卫生项目', '连续健康管理']
    },
    cta: {
      title: '需要了解数字医疗方案？',
      description: '欢迎与我们联系，获取更适配业务场景的产品组合与合作方式。'
    }
  },
  digitalize: {
    eyebrow: '核心产品',
    label: '数据空间',
    title: '围绕数据流通、数字化运营与安全协同，构建可信的平台能力',
    intro:
      '从数字化服务平台到学术营销，再到隐私计算与可信协同，数据空间产品帮助机构以更稳妥的方式释放数据价值。',
    bannerPreview: dataOverviewPreview,
    bannerCaption: '围绕协同、安全与持续运营的产品能力',
    highlights: ['数字化服务平台', '学术营销协同', '隐私计算与可信流通'],
    sections: [
      {
        id: 'service-platform',
        title: '好心大夫数字化服务综合平台',
        summary:
          '随着医药带量采购、一致性评价、DRGS等政策的持续推进，特别是近期医药反腐，让药企纷纷聚焦数字化转型。向数字化转型既是机遇，也是挑战，选择适合自身战略部署的产品组合才是赋能的新方向。',
        points: [
          '面向业务转型的综合平台能力',
          '帮助组织建立更连续的数字化运营链路',
          '支持更贴合实际部署的产品组合'
        ],
        preview: servicePlatformPreview
      },
      {
        id: 'academic-marketing',
        title: '医药数字化学术营销平台',
        summary:
          '医药数字化营销的内核，主要指药企采用数字系统开展医生虚拟拜访、线上学术会议、最新学术进展分析等，对旗下的处方药产品进行在线营销，以提高销量。',
        points: [
          '支持虚拟拜访与线上学术活动',
          '支撑内容传播与学术进展分析',
          '提升数字化营销效率'
        ],
        preview: academicMarketingPreview
      },
      {
        id: 'secure-data-space',
        title: '医疗体系数据空间安全平台',
        summary:
          '隐私计算智能服务平台：是以联邦学习FL、安全多方计算MPC、可信硬件执行环境TEE等隐私数据保护技术工具为基础服务的平台。核心价值：保证原始数据不出本地即可完成多方数据联合建模和联合计算能力，同时支持安全隐私保护集合求交、安全隐私查询、安全统计分析。实现各合作机构数据在流通、计算过程中，端到端的安全保护和可审计，推动跨行业的可信数据价值的融合和协同，很好地应对了业界数据孤岛的挑战。',
        points: [
          '联邦学习、MPC、TEE 等隐私技术支撑',
          '支持多方联合建模与安全统计分析',
          '强化数据流通、计算与审计安全'
        ],
        preview: secureDataSpacePreview
      }
    ],
    summary: {
      eyebrow: '平台能力',
      title: '让数据价值在可信的前提下被持续释放',
      text: '数据空间产品围绕平台建设、业务协同和隐私保护展开，帮助合作机构在流通、计算与治理过程中建立更可靠的数字基础。',
      items: ['数字化平台建设', '学术营销协同', '可信数据流通']
    },
    cta: {
      title: '想了解更适配的数据空间方案？',
      description:
        '欢迎与我们沟通业务结构、协同方式与安全要求，我们会提供更清晰的路径建议。'
    }
  }
}

export const aboutPage = {
  hero: {
    eyebrow: '关于我们',
    title: '以可信数据空间为基础，连接场景、治理与长期价值',
    description:
      '我们相信，数据是推动人工智能发展的关键要素，也是赋能各行各业迈向数字时代的强大动力。',
    image: aboutHeroImage
  },
  intro: {
    title: '公司简介',
    lead: '专注于构建可信的数据空间。我们秉承"因为信任，所以简单"的经营理念，致力于简化数据的复杂性，让信息的力量更加直观和易于管理。',
    paragraphs: [
      '我们提供全面的数智化解决方案，包括但不限于数据标准规范、数据强化治理和数据安全保障。',
      '我们期待与您携手，共同探索数据服务的无限可能，共创数字化转型的美好未来。在这条充满挑战与机遇的道路上，愿我们以梦为马、不负韶华。'
    ],
    bullets: [
      '数据标准规范：致力于提升数据的一致性和准确性，为客户提供坚实的数据基础。',
      '数据强化治理：通过先进的技术和策略，优化数据管理流程，提升数据的质量和可用性。',
      '数据安全保障：采用多层次安全措施，保护客户数据不受威胁，保障数据的安全性和隐私性。'
    ],
    image: aboutPreviewImage
  },
  values: [
    {
      title: '使命',
      text: '数据标准规范、数据强化治理、数据安全保障',
      icon: valueMissionIcon
    },
    {
      title: '愿景',
      text: '可信数据空间服务提供商',
      icon: valueVisionIcon
    },
    {
      title: '经营理念',
      text: '因为信任，所以简单',
      icon: valuePhilosophyIcon
    },
    {
      title: '战略定位',
      text: '以数据要素驱动AI发展，助力全行业迈向数字时代',
      icon: valueStrategyIcon
    }
  ],
  timeline: [
    {
      year: '2024年',
      title: '市级两癌筛查平台1.0上线'
    },
    {
      year: '2023年',
      title: '乐康独立运营',
      highlight: true
    },
    {
      year: '2022年',
      title: '慢病领域院内外一体化 医患互动私域管理平台'
    },
    {
      year: '2021年',
      title: '好心大夫健康管理平台2.0上线'
    },
    {
      year: '2020年',
      title: '心血管领域的患教直播运营 病例科研项目合作'
    },
    {
      year: '2019年',
      title: '城市社区高血压综合管理适宜技术研究及示范推广'
    },
    {
      year: '2018年',
      title: '好心大夫健康管理平台1.0上线'
    },
    {
      year: '2015年',
      title: '一个美好的开始'
    }
  ]
}

export const contactPage = {
  hero: {
    eyebrow: '商务合作',
    title: '欢迎与我们联系',
    description:
      '围绕数字医疗、数据治理与数据空间安全等场景，我们希望以稳妥、清晰的方式参与您的项目推进。'
  },
  cards: [
    {
      title: 'QQ',
      text: companyProfile.phone,
      href: companyProfile.phoneHref,
      icon: footerPhoneIcon
    },
    {
      title: '商务合作',
      text: companyProfile.email,
      href: companyProfile.emailHref,
      icon: footerEmailIcon
    },
    {
      title: '联系地址',
      text: companyProfile.address,
      href: null,
      icon: footerAddressIcon
    }
  ],
  officeImage,
  mapNote:
    '地图用于快速定位办公位置；如需沟通合作细节，建议优先通过电话或邮箱直接联系。'
}
